<template>
  <div class="with-side-panel">
    -
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Übersicht
            </h6>
          </div>

          <div class="element-box overflow-hidden">

            <div class="row">

<!--              <div class="col-12">-->
<!--                <h5 class="form-header mb-4">-->
<!--                  Berichtsportale-->
<!--                </h5>-->

<!--                &lt;!&ndash; 1. Einzelcoaching &ndash;&gt;-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.privateCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_COACH',-->
<!--                      'ROLE_THERAPIST',-->
<!--                      'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_AMDL',-->
<!--                      'ROLE_PRACTICE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_MARKETING',-->
<!--                      'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                    ]"-->
<!--                    route-name="privateCoachingNewAndActiveList"-->
<!--                    coaching-type="private"-->
<!--                    label="Einzelcoaching"-->
<!--                />-->

<!--                &lt;!&ndash; 2. Gruppenmaßnahmen &ndash;&gt;-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.groupCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_COACH',-->
<!--                      'ROLE_THERAPIST',-->
<!--                      'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_AMDL',-->
<!--                      'ROLE_PRACTICE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_MARKETING',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                     ]"-->
<!--                    route-name="groupCoachingNewAndActiveList"-->
<!--                    icon="fa-users"-->
<!--                    coaching-type="group"-->
<!--                    label="Gruppenmaßnahmen"-->
<!--                />-->

<!--                &lt;!&ndash; 3. Soziotherapie &ndash;&gt;-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.socioTherapyCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_COACH',-->
<!--                      'ROLE_THERAPIST',-->
<!--                      'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_MARKETING',-->
<!--                      'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',-->
<!--                      'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                    ]"-->
<!--                    route-name="socioTherapyCoachingNewAndActiveList"-->
<!--                    icon="fa-hand-holding-heart"-->
<!--                    coaching-type="socioTherapy"-->
<!--                    label="Soziotherapie"-->
<!--                />-->

<!--                &lt;!&ndash; 4. Betreutes Wohnen &ndash;&gt;-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.assistedLivingCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_COACH',-->
<!--                      'ROLE_THERAPIST',-->
<!--                      'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_MARKETING',-->
<!--                      'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',-->
<!--                      'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                    ]"-->
<!--                    route-name="assistedLivingCoachingNewAndActiveList"-->
<!--                    icon="fa-house-chimney-user"-->
<!--                    coaching-type="assistedLiving"-->
<!--                    label="Betreutes Wohnen"-->
<!--                />-->

<!--                &lt;!&ndash; 5. DRV Fallmanagement &ndash;&gt;-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.caseManagementCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_COACH',-->
<!--                      'ROLE_THERAPIST',-->
<!--                       'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_PRACTICE_MANAGER',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                    ]"-->
<!--                    route-name="caseManagementCoachingNewAndActiveList"-->
<!--                    icon="fa-briefcase"-->
<!--                    coaching-type="caseManagement"-->
<!--                    label="DRV Fallmanagement"-->
<!--                />-->

<!--                &lt;!&ndash; 6. Private Weiterbildung &ndash;&gt;-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.privateLearningCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_COACH',-->
<!--                      'ROLE_THERAPIST',-->
<!--                      'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_MARKETING',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                    ]"-->
<!--                    route-name="privateLearningCoachingNewAndActiveList"-->
<!--                    icon="fa-graduation-cap"-->
<!--                    coaching-type="privateLearning"-->
<!--                    label="Private Weiterbildung"-->
<!--                />-->

<!--              </div>-->

<!--              <div class="col-12"-->
<!--                   v-if="-->
<!--                  companySettings.privateCoachingEnabled && (-->
<!--                  currentUserRole === 'ROLE_ADMIN' ||-->
<!--                  currentUserRole === 'ROLE_SITE_SUPPORT' ||-->
<!--                  currentUserRole === 'ROLE_SITE_MANAGER' ||-->
<!--                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||-->
<!--                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||-->
<!--                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||-->
<!--                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||-->
<!--                  currentUserRole === 'ROLE_ACCOUNTANT' ||-->
<!--                  currentUserRole === 'ROLE_ASSISTANT_VQ' )">-->
<!--                <hr class="my-4 border-top" style="border-color: #e2e8f0 !important;" />-->
<!--                <h5 class="form-header mb-4">-->
<!--                  Ausstehendes Coaching-->
<!--                </h5>-->
<!--                <CoachingButton-->
<!--                    :enabled="companySettings.privateCoachingEnabled"-->
<!--                    :current-user-role="currentUserRole"-->
<!--                    :allowed-roles="[-->
<!--                      'ROLE_ADMIN',-->
<!--                      'ROLE_SITE_SUPPORT',-->
<!--                      'ROLE_SITE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_AMDL',-->
<!--                      'ROLE_PRACTICE_MANAGER',-->
<!--                      'ROLE_HEAD_OF_MARKETING',-->
<!--                      'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES',-->
<!--                      'ROLE_ACCOUNTANT',-->
<!--                      'ROLE_ASSISTANT_VQ'-->
<!--                    ]"-->
<!--                    route-name="privateCoachingInquiryOverviewList"-->
<!--                    coaching-type="privateInquiry"-->
<!--                    label="Einzelcoaching ausstehend"-->
<!--                />-->
<!--              </div>-->


            </div>


                        <h5 class="form-header mb-4">
                          Berichtsportale
                        </h5>

                        <div class="custom_responsive_element"
                             v-if="
                              companySettings.privateCoachingEnabled && (
                              currentUserRole === 'ROLE_ADMIN' ||
                              currentUserRole === 'ROLE_COACH' ||
                              currentUserRole === 'ROLE_THERAPIST' ||
                              currentUserRole === 'ROLE_SITE_SUPPORT' ||
                              currentUserRole === 'ROLE_SITE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                              currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                              currentUserRole === 'ROLE_ACCOUNTANT' ||
                              currentUserRole === 'ROLE_ASSISTANT_VQ')">
                          <router-link
                              :to="{ name: 'privateCoachingNewAndActiveList' }"
                              class="btn btn-primary btn-block"
                              style="padding: 10px">
                            Einzelcoaching
                          </router-link>
                        </div>
                        <div class="custom_responsive_element"
                             v-if="
                              companySettings.groupCoachingEnabled && (
                              currentUserRole === 'ROLE_ADMIN' ||
                              currentUserRole === 'ROLE_COACH' ||
                              currentUserRole === 'ROLE_THERAPIST' ||
                              currentUserRole === 'ROLE_SITE_SUPPORT' ||
                              currentUserRole === 'ROLE_SITE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                              currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                              currentUserRole === 'ROLE_ACCOUNTANT' ||
                              currentUserRole === 'ROLE_ASSISTANT_VQ')">
                          <router-link
                              :to="{ name: 'groupCoachingNewAndActiveList' }"
                              class="btn btn-primary btn-block"
                              style="padding: 10px">
                            Gruppenmaßnahmen
                          </router-link>
                        </div>
                        <div class="custom_responsive_element"
                             v-if="
                              companySettings.socioTherapyCoachingEnabled && (
                              currentUserRole === 'ROLE_ADMIN' ||
                              currentUserRole === 'ROLE_COACH' ||
                              currentUserRole === 'ROLE_THERAPIST' ||
                              currentUserRole === 'ROLE_SITE_SUPPORT' ||
                              currentUserRole === 'ROLE_SITE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                              currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                              currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                              currentUserRole === 'ROLE_ACCOUNTANT' ||
                              currentUserRole === 'ROLE_ASSISTANT_VQ')">
                          <router-link
                              :to="{ name: 'socioTherapyCoachingNewAndActiveList' }"
                              class="btn btn-primary btn-block"
                              style="padding: 10px">
                            Soziotherapie
                          </router-link>
                        </div>
                        <div class="custom_responsive_element"
                             v-if="
                              companySettings.assistedLivingCoachingEnabled && (
                              currentUserRole === 'ROLE_ADMIN' ||
                              currentUserRole === 'ROLE_COACH' ||
                              currentUserRole === 'ROLE_THERAPIST' ||
                              currentUserRole === 'ROLE_SITE_SUPPORT' ||
                              currentUserRole === 'ROLE_SITE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                              currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                              currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
                              currentUserRole === 'ROLE_ACCOUNTANT' ||
                              currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                          <router-link
                              :to="{ name: 'assistedLivingCoachingNewAndActiveList' }"
                              class="btn btn-primary btn-block"
                              style="padding: 10px">
                            Betreutes Wohnen
                          </router-link>
                        </div>
                        <div class="custom_responsive_element"
                             v-if="
                              companySettings.caseManagementCoachingEnabled && (
                              currentUserRole === 'ROLE_ADMIN' ||
                              currentUserRole === 'ROLE_COACH' ||
                              currentUserRole === 'ROLE_THERAPIST' ||
                              currentUserRole === 'ROLE_SITE_SUPPORT' ||
                              currentUserRole === 'ROLE_SITE_MANAGER' ||
                              currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                              currentUserRole === 'ROLE_ACCOUNTANT' ||
                              currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                          <router-link
                              :to="{ name: 'caseManagementCoachingNewAndActiveList' }"
                              class="btn btn-primary btn-block"
                              style="padding: 10px">
                            DRV Fallmanagement
                          </router-link>
                        </div>
                        <div class="custom_responsive_element"
                             v-if="
                              companySettings.privateLearningCoachingEnabled && (
                              currentUserRole === 'ROLE_ADMIN' ||
                              currentUserRole === 'ROLE_COACH' ||
                              currentUserRole === 'ROLE_THERAPIST' ||
                              currentUserRole === 'ROLE_SITE_SUPPORT' ||
                              currentUserRole === 'ROLE_SITE_MANAGER' ||
                              currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                              currentUserRole === 'ROLE_ACCOUNTANT' ||
                              currentUserRole === 'ROLE_ASSISTANT_VQ' )">
                          <router-link
                              :to="{ name: 'privateLearningCoachingNewAndActiveList' }"
                              class="btn btn-primary btn-block"
                              style="padding: 10px">
                            Private Weiterbildung
                          </router-link>
                        </div>

          </div>

          <div class="element-box overflow-hidden"
               v-if="
                  companySettings.privateCoachingEnabled && (
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' )">
            <h5 class="form-header mb-4">
              Ausstehendes Coaching
            </h5>
            <div class="custom_responsive_element">
              <router-link
                  :to="{ name: 'privateCoachingInquiryOverviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Einzelcoaching ausstehend
              </router-link>
            </div>
          </div>

        </div>
      </div>

      <Sidebar/>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/FormSidebar.vue';
import {piniaUserStore} from '@/store/piniaUserStore';
import {computed} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import CoachingButton from "@/components/button/CoachingButton.vue";

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
</script>

<style scoped>
.custom_responsive_element {
  margin-bottom: 12px;
}

.custom_responsive_element:last-child {
  margin-bottom: 0;
}
</style>